export function getPlannerKey(expense = {}) {
  if (!expense) return '';

  if (expense.plannerKey) return String(expense.plannerKey);

  if (expense.id !== undefined && expense.id !== null && expense.id !== '') {
    return `id:${expense.id}`;
  }

  const categoryPart = expense.categoryKey || expense.category || 'uncategorized';
  const namePart = expense.name || 'unnamed';
  return `${categoryPart}:${namePart}`;
}
